import Component from '@glimmer/component';

/**
 * @param {Function}    entryExportJob
 * @param {Function}    cancel
 */
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class EntryExportJob extends Component {}
